import FmAndTvsDetails from './FmAndTvsDetails'

export default FmAndTvsDetails
